const PlusCircle = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M36.6667 19.9999C36.6667 29.2047 29.2048 36.6666 20 36.6666C10.7953 36.6666 3.33337 29.2047 3.33337 19.9999C3.33337 10.7952 10.7953 3.33325 20 3.33325C29.2048 3.33325 36.6667 10.7952 36.6667 19.9999ZM26.25 19.9999C26.25 20.6903 25.6904 21.2499 25 21.2499H15C14.3097 21.2499 13.75 20.6903 13.75 19.9999C13.75 19.3096 14.3097 18.7499 15 18.7499H25C25.6904 18.7499 26.25 19.3096 26.25 19.9999Z" fill="#1C225A" />
        </svg>
    )
}

export default PlusCircle